import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import SearchInput from 'components/field/SearchInput';
import Popper from 'components/global/Popper';
import Typography from 'components/global/Typography';

import useUpdateEffect from 'hooks/useUpdateEffect';

import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

import * as S from '../Table.styled';
import TableFilterMenuItem from './TableFilterMenuItem';

const TableFilterMenu = (props) => {
	const { table, columnFilters, setColumnFilters, filtersMenuButtonRef } = props;

	const { t } = useTranslation();

	const [filterColumnsMenuSearchValue, setFilterColumnsMenuSearchValue] = useState(null);
	const [filteredFilterColumnsMenuColumns, setFilteredFilterColumnsMenuColumns] = useState(
		table.getAllColumns().filter((col) => col.getCanFilter())
	);

	useUpdateEffect(() => {
		const filterableColumns = table.getAllColumns().filter((col) => col.getCanFilter());

		if (filterColumnsMenuSearchValue) {
			setFilteredFilterColumnsMenuColumns(
				filterableColumns.filter((col) =>
					t(col.id).toLowerCase().includes(filterColumnsMenuSearchValue.toLowerCase())
				)
			);
		} else {
			setFilteredFilterColumnsMenuColumns(filterableColumns);
		}
	}, [filterColumnsMenuSearchValue]);

	return (
		filtersMenuButtonRef && (
			<Popper refElement={filtersMenuButtonRef} placement="bottom-end">
				{() => (
					<S.MenuWrapper>
						<S.MobileFilterMenu className="columnsMenu">
							<S.FilterHeader>
								<Typography variant="p1" fontWeight="500" noWrap className="desktop-hidden">
									filters
								</Typography>

								<SearchInput
									value={filterColumnsMenuSearchValue}
									setValue={setFilterColumnsMenuSearchValue}
								/>
							</S.FilterHeader>

							{filteredFilterColumnsMenuColumns.map((column, index) => (
								<TableFilterMenuItem
									key={index}
									column={column}
									isFiltered={columnFilters?.some((obj) => obj.id === column.id)}
								/>
							))}
							<S.FilterColumnsButtonContainer className="desktop-hidden">
								<Button
									label="reset"
									icon={faTrashAlt}
									onClick={() => {
										setColumnFilters([]);
									}}
									variant="outline"
								/>
							</S.FilterColumnsButtonContainer>
						</S.MobileFilterMenu>
					</S.MenuWrapper>
				)}
			</Popper>
		)
	);
};

export default TableFilterMenu;
